import React, { ReactElement } from 'react';

interface IconProps {
  color?: string;
}

const PrivacyDismissedMemberIcon = ({ color = '#E2C92D' }: IconProps): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <mask
        id="a"
        width={26}
        height={26}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#D9D9D9" d="M0 0h26v26H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill={color}
          d="M16.44 9.018a4.65 4.65 0 0 1 1.37 3.45c0 .302-.109.557-.325.766-.215.209-.474.313-.775.313a1.04 1.04 0 0 1-.765-.313 1.04 1.04 0 0 1-.314-.765 2.13 2.13 0 0 0-.061-1.111 2.31 2.31 0 0 0-.561-.913 2.559 2.559 0 0 0-.913-.585 2.059 2.059 0 0 0-1.138-.085 1 1 0 0 1-.75-.324 1.067 1.067 0 0 1-.31-.763c0-.292.104-.542.31-.749.208-.206.457-.31.75-.31a4.368 4.368 0 0 1 1.85.306 4.756 4.756 0 0 1 1.632 1.083ZM13 6.5c-.304 0-.6.012-.889.034a7.163 7.163 0 0 0-.868.123 1.334 1.334 0 0 1-.907-.167 1.204 1.204 0 0 1-.55-.721 1.108 1.108 0 0 1 .112-.911 1.01 1.01 0 0 1 .731-.514c.39-.077.781-.132 1.175-.163.394-.032.793-.048 1.196-.048 2.504 0 4.796.66 6.875 1.979 2.08 1.32 3.668 3.1 4.764 5.342.076.157.135.32.175.489.04.168.061.34.061.516 0 .175-.015.348-.044.519-.029.17-.082.335-.158.492-.321.697-.711 1.35-1.17 1.963a13.164 13.164 0 0 1-1.517 1.698.963.963 0 0 1-.82.283 1.104 1.104 0 0 1-.778-.453 1.263 1.263 0 0 1-.266-.887 1.25 1.25 0 0 1 .382-.826c.403-.402.774-.837 1.114-1.303.34-.466.64-.961.902-1.486a10.732 10.732 0 0 0-3.916-4.344C16.904 7.038 15.036 6.5 13 6.5Zm0 14.284c-2.445 0-4.684-.659-6.716-1.976-2.032-1.318-3.63-3.057-4.795-5.218a2.142 2.142 0 0 1-.222-.542 2.34 2.34 0 0 1-.075-.59c0-.202.02-.396.061-.582.04-.186.11-.371.21-.555.352-.71.763-1.385 1.233-2.027.47-.642 1-1.231 1.593-1.769L2.106 5.321a1.093 1.093 0 0 1-.307-.801c.006-.31.116-.57.327-.78.212-.212.477-.318.794-.318.318 0 .583.106.794.317l18.45 18.45c.21.21.32.471.327.78.007.308-.103.575-.328.8a1.073 1.073 0 0 1-.79.318c-.316 0-.58-.106-.791-.317l-3.643-3.596a12.06 12.06 0 0 1-1.942.46c-.659.1-1.324.15-1.997.15ZM5.954 9.171c-.506.469-.967.977-1.383 1.524a10.56 10.56 0 0 0-1.085 1.763 10.602 10.602 0 0 0 3.907 4.347c1.702 1.074 3.571 1.611 5.607 1.611.34 0 .672-.02.998-.061.326-.041.659-.086.998-.136l-.975-1.03c-.177.05-.347.087-.51.11a3.709 3.709 0 0 1-.51.034c-1.355 0-2.506-.474-3.454-1.422-.948-.948-1.422-2.1-1.422-3.453 0-.177.01-.347.031-.51.02-.164.054-.334.1-.511L5.953 9.17Z"
        />
      </g>
    </svg>
  );
};

export default PrivacyDismissedMemberIcon;
